/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_UsedInputs */

const vi_aroma_sampling_used = /** @type {(inputs: Aroma_Sampling_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã dùng (kg)`)
};

/**

* @param {Aroma_Sampling_UsedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_used = /** @type {((inputs?: Aroma_Sampling_UsedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_UsedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_used(inputs)
});